import $ from 'jquery';

class Standfirst {
    constructor () {
        this.$expandBtn      = $('.js-standfirst__expand');
        this.expandTextClass = '.js-standfirst__expand-text';
        this.wrapperClass    = '.js-standfirst';

        this.$expandBtn.on('click', (e) => {
            const $elem = $(e.currentTarget);

            $elem.closest(this.wrapperClass).toggleClass('is-open').find(this.expandTextClass).slideToggle(300);
        });
    }
}

export default Standfirst;
